// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__37Nlx","loaderOuter":"PageOverlayLoader_loaderOuter__1Wq1G"};